import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function LegalPage({ eyebrow, title, lastUpdated, sections, testIdPrefix }) {
    return (
        <div className="min-h-screen relative grain">
            <Header />
            <main className="max-w-[900px] mx-auto px-6 md:px-10 pt-14 pb-24">
                <div className="overline text-[#5C5C5C]">{eyebrow}</div>
                <h1 className="font-display font-light text-5xl md:text-6xl mt-2 tracking-tight">{title}</h1>
                {lastUpdated && (
                    <div className="font-body text-sm text-[#5C5C5C] mt-4">Última atualização: {lastUpdated}</div>
                )}

                <div data-testid={`${testIdPrefix}-content`} className="mt-12 bg-white rounded-3xl p-8 md:p-12 border border-black/5">
                    {sections.map((s, i) => (
                        <section key={i} className="mb-10 last:mb-0">
                            <h2 className="font-display text-2xl tracking-tight">{s.heading}</h2>
                            {(s.paragraphs || []).map((p, j) => (
                                <p key={j} className="font-body text-[#3D3D3D] mt-4 leading-relaxed">{p}</p>
                            ))}
                            {s.list && (
                                <ul className="font-body text-[#3D3D3D] mt-4 space-y-2">
                                    {s.list.map((li, k) => (
                                        <li key={k} className="flex gap-3 leading-relaxed"><span className="text-[#00D4D4] mt-1.5 w-1 h-1 rounded-full bg-[#00D4D4] shrink-0" />{li}</li>
                                    ))}
                                </ul>
                            )}
                        </section>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}
